import * as SignalR from '@microsoft/signalr'
import { inject, injectable, named } from "inversify";
import { IAuthService } from '../security/AuthService';
import { HubConnectionState } from '@microsoft/signalr';
import container from '../../wires/Bootstrapper';
import SERVICE_IDENTIFIER from '../../wires/Identifiers';

export interface ISignalRServiceHandler {
    AddEventHandlerFor(event: string, handler: (...args: any[]) => void): void;
    RemoveEventHandlerFor(event: string, handler: (...args: any[]) => void): void;
    AddToGroupCliente(clienteId: string)
    RemoveFromGroupCliente(clienteId: string)
    IsConnected(): boolean

}

export interface IHandlerDelegate {
    newMethod: (...args: any[]) => void
}

@injectable()
export class SignalRServiceHandler implements ISignalRServiceHandler {
    authService: IAuthService;
    connection: SignalR.HubConnection;
    clienteId: string = null

    delegates: { [id: string]: IHandlerDelegate; } = {};

    AddEventHandlerFor = (event: string, handler: (...args: any[]) => void) => {
        this.connection.on(event, handler);
    };

    RemoveEventHandlerFor = (event: string, handler: (...args: any[]) => void) => {
        this.connection.off(event, handler)
    };

    AddToGroupCliente = async (clienteId: string) => {
        this.clienteId = clienteId
        await this.connection.invoke<void>("AddToGroupCliente", clienteId)
    }

    RemoveFromGroupCliente = async (clienteId: string) => {
        await this.connection.invoke<void>("RemoveFromGroupCliente", clienteId)
    }

    IsConnected = (): boolean => {
        return this.connection.state == HubConnectionState.Connected
    }

    private onDisconnected = async (error: Error) => {
        console.log('Connection closed!')

        // Ritento la connessione
        console.log('Ritento la connessione a SignalR')
        await this.connection.start()

        // Rientro nel gruppo dell'ultima pratica
        if (this.clienteId != null) {
            console.log(`Aggiunta al gruppo cliente ${this.clienteId}`)
            this.AddToGroupCliente(this.clienteId)
        }
    }

    constructor() {
        this.authService = container.get(SERVICE_IDENTIFIER.AUTH_SERVICE);
        this.connection = new SignalR.HubConnectionBuilder()
            .withUrl("/NotificationHub",
                {
                    accessTokenFactory: () => this.authService.getToken()
                })
            .configureLogging(SignalR.LogLevel.Debug)
            .withAutomaticReconnect()
            .build();

        this.connection
            .start()
            .then(() => console.log('Connection started!'))
            .catch(err => console.log('Error while establishing connection :(' + err + ')'));

        this.connection.onclose(error => this.onDisconnected(error))

    }

}
